export const SHOPPING_ASSISTANT = 'ai_shopping_assistant'
export const SHOPPING_ASSISTANT_NEW = 'ai_shopping_assistant_new'
